/* eslint-disable */

export enum PERMISSION {
  LOGIN_GOOGLE = 'LOGIN_GOOGLE',

  AI_AGENT_ACCESS = 'AI_AGENT_ACCESS',
  DELIVERY_360_MODULE_ENTRY = 'DELIVERY_360_MODULE_ENTRY',
  AI_AGENT_ACCESS_LEGACY = 'AI_AGENT_ACCESS_LEGACY',
  AI_AGENT_MANAGE = 'AI_AGENT_MANAGE',
  AI_ENVIRONMENT_ACCESS_APPROVE = 'AI_ENVIRONMENT_ACCESS_APPROVE',
  NOTIFICATIONS_TEMPLATES_LIST = 'NOTIFICATIONS_TEMPLATES_LIST',
  ADMIN_PANEL_ENTRY = 'ADMIN_PANEL_ENTRY',
  ADMIN_USERS_CREATE = 'ADMIN_USERS_CREATE',
  ADMIN_CHANGE_STORAGE_LIMIT = 'ADMIN_CHANGE_STORAGE_LIMIT',

  ADMIN_COST_CENTER_MODULE_ENTRY = 'ADMIN_COST_CENTER_MODULE_ENTRY',
  ADMIN_COST_CENTER_LIST = 'ADMIN_COST_CENTER_LIST',
  ADMIN_COST_CENTER_USERS_LIST = 'ADMIN_COST_CENTER_USERS_LIST',
  ADMIN_COST_CENTER_CREATE = 'ADMIN_COST_CENTER_CREATE',
  ADMIN_COST_CENTER_DELETE = 'ADMIN_COST_CENTER_DELETE',
  ADMIN_COST_CENTER_UPDATE = 'ADMIN_COST_CENTER_UPDATE',
  ADMIN_COST_CENTER_USERS_UPDATE = 'ADMIN_COST_CENTER_USERS_UPDATE',

  CONSULTANT_SPECIALIZATIONS_TAB_ENTRY = 'CONSULTANT_SPECIALIZATIONS_TAB_ENTRY',

  EMPLOYEE_SPECIALIZATIONS_LIST = 'EMPLOYEE_SPECIALIZATIONS_LIST',
  EMPLOYEE_SPECIALIZATIONS_SAVE = 'EMPLOYEE_SPECIALIZATIONS_SAVE',
  EMPLOYEE_SPECIALIZATIONS_DELETE = 'EMPLOYEE_SPECIALIZATIONS_DELETE',

  ADMIN_CP_MODULE_ENTRY = 'ADMIN_CP_MODULE_ENTRY',
  ADMIN_CP_USERS_LIST = 'ADMIN_CP_USERS_LIST',
  ADMIN_CP_USERS_CREATE = 'ADMIN_CP_USERS_CREATE',
  ADMIN_CP_USERS_DELETE = 'ADMIN_CP_USERS_DELETE',
  ADMIN_CP_USERS_UPDATE = 'ADMIN_CP_USERS_UPDATE',

  ADMIN_CURRENCY_CONVERTER_MODULE_ENTRY = 'ADMIN_CURRENCY_CONVERTER_MODULE_ENTRY',
  ADMIN_CURRENCY_CONVERTER_MODULE_LIST = 'ADMIN_CURRENCY_CONVERTER_MODULE_LIST',
  ADMIN_CURRENCY_CONVERTER_MODULE_SAVE = 'ADMIN_CURRENCY_CONVERTER_MODULE_SAVE',
  ADMIN_CURRENCY_CONVERTER_MODULE_UPDATE = 'ADMIN_CURRENCY_CONVERTER_MODULE_UPDATE',
  ADMIN_CURRENCY_CONVERTER_MODULE_DELETE = 'ADMIN_CURRENCY_CONVERTER_MODULE_DELETE',
  ADMIN_SETTINGS_TIMELOG_MODULE_ENTRY = 'ADMIN_SETTINGS_TIMELOG_MODULE_ENTRY',
  ADMIN_SETTINGS_MODULE_ENTRY = 'ADMIN_SETTINGS_MODULE_ENTRY',

  ADMIN_IMPERSONATE = 'ADMIN_IMPERSONATE',

  CONSULTANT_UPDATE_MODULE_ENTRY = 'CONSULTANT_UPDATE_MODULE_ENTRY',
  CONSULTANT_REGISTRATION_MODULE_ENTRY = 'CONSULTANT_REGISTRATION_MODULE_ENTRY',
  KNOWLEDGE_SHARING_MODULE_ENTRY = 'KNOWLEDGE_SHARING_MODULE_ENTRY',

  ALLOCATIONS_MANAGER_MODULE_ENTRY = 'ALLOCATIONS_MANAGER_MODULE_ENTRY',
  ABSENCES_MANAGER_MODULE_ENTRY = 'ABSENCES_MANAGER_MODULE_ENTRY',

  CSAT_MANAGER_MODULE_ENTRY = 'CSAT_MANAGER_MODULE_ENTRY',
  GRADE_MATRIX_MANAGER_MODULE_ENTRY = 'GRADE_MATRIX_MANAGER_MODULE_ENTRY',
  GRADE_MATRIX_CONSULTANT_ENTRY = 'CONSULTANT_GRADE_MATRIX_TAB_ENTRY',
  GRADE_MATRIX_MODULE_ENTRY = 'GRADE_MATRIX_MODULE_ENTRY',
  GRADE_MATRIX_ANALYSIS_MODULE_ENTRY = 'GRADE_MATRIX_ANALYSIS_MODULE_ENTRY',
  GRADE_MATRIX_SETTINGS_LIST = 'GRADE_MATRIX_SETTINGS_LIST',
  GRADE_MATRIX_SETTINGS_EDIT = 'GRADE_MATRIX_SETTINGS_EDIT',
  GRADE_MATRIX_SCORES_LIST = 'GRADE_MATRIX_SCORES_LIST',
  GRADE_MATRIX_SCORES_EDIT = 'GRADE_MATRIX_SCORES_EDIT',
  GRADE_MATRIX_CONSULTANTS_LIST = 'GRADE_MATRIX_CONSULTANTS_LIST',
  GRADE_MATRIX_PROFILES_LIST = 'GRADE_MATRIX_PROFILES_LIST',
  GRADE_MATRIX_PROFILES_EDIT = 'GRADE_MATRIX_PROFILES_EDIT',
  GRADE_MATRIX_CSAT = 'GRADE_MATRIX_CSAT',
  GRADE_MATRIX_SKILLS = 'GRADE_MATRIX_SKILLS',

  CSAT_SETUP_MODULE_ENTRY = 'CSAT_SETUP_MODULE_ENTRY',
  CSAT_LIST = 'CSAT_LIST',
  CSAT_CREATE = 'CSAT_CREATE',
  CSAT_UPDATE = 'CSAT_UPDATE',
  CSAT_DELETE = 'CSAT_DELETE',

  TENANTS_MODULE_ENTRY = 'TENANTS_MODULE_ENTRY',
  CUSTOMER_PORTALS_SETUP_MODULE_ENTRY = 'CUSTOMER_PORTALS_SETUP_MODULE_ENTRY',
  USERS_SETUP_MODULE_ENTRY = 'USERS_SETUP_MODULE_ENTRY',
  ITBM_SYNC_MODULE_ENTRY = 'ITBM_SYNC_MODULE_ENTRY',

  EQUIPMENTS_UPDATE = 'EQUIPMENTS_UPDATE',
  EQUIPMENTS_CREATE = 'EQUIPMENTS_CREATE',
  EQUIPMENTS_DELETE = 'EQUIPMENTS_DELETE',
  EQUIPMENTS_LIST = 'EQUIPMENTS_LIST',
  EQUIPMENTS_MODULE_ENTRY = 'EQUIPMENTS_MODULE_ENTRY',

  HOLIDAYS_UPDATE = 'HOLIDAYS_UPDATE',
  HOLIDAYS_CREATE = 'HOLIDAYS_CREATE',
  HOLIDAYS_DELETE = 'HOLIDAYS_DELETE',
  HOLIDAYS_LIST = 'HOLIDAYS_LIST',
  HOLIDAYS_MODULE_ENTRY = 'HOLIDAYS_MODULE_ENTRY',

  DOCUMENTS_DOWNLOAD = 'DOCUMENTS_DOWNLOAD',
  DOCUMENTS_UPLOAD = 'DOCUMENTS_UPLOAD',
  DOCUMENTS_DELETE = 'DOCUMENTS_DELETE',
  DOCUMENTS_CREATE_FOLDER = 'DOCUMENTS_CREATE_FOLDER',

  LANGUAGE_EMPLOYEE_LIST = 'LANGUAGE_EMPLOYEE_LIST',
  LANGUAGE_EMPLOYEE_CREATE = 'LANGUAGE_EMPLOYEE_CREATE',
  LANGUAGE_EMPLOYEE_UPDATE = 'LANGUAGE_EMPLOYEE_UPDATE',
  LANGUAGE_EMPLOYEE_DELETE = 'LANGUAGE_EMPLOYEE_DELETE',

  ABSENCES_MODULE_ENTRY = 'ABSENCES_MODULE_ENTRY',
  ABSENCES_CREATE = 'ABSENCES_CREATE',

  CONSULTANT_MODULE_ENTRY = 'CONSULTANT_MODULE_ENTRY',
  DASHBOARD_MODULE_ENTRY = 'DASHBOARD_MODULE_ENTRY',
  DASHBOARD_THS = 'DASHBOARD_THS',
  TIME_LOGGING_MODULE_ENTRY = 'TIME_LOGGING_MODULE_ENTRY',
  EU_TIME_TRACKING_MODULE_ENTRY = 'EU_TIME_TRACKING_MODULE_ENTRY',
  ALLOCATIONS_MODULE_ENTRY = 'ALLOCATIONS_MODULE_ENTRY',
  ALLOCATIONS_CREATE = 'ALLOCATIONS_CREATE',
  ALLOCATIONS_UPDATE = 'ALLOCATIONS_UPDATE',
  ALLOCATIONS_SPLIT = 'ALLOCATIONS_SPLIT',

  CV_MODULE_ENTRY = 'CV_MODULE_ENTRY',
  CV_STUDIO_MODULE_ENTRY = 'CV_STUDIO_MODULE_ENTRY',
  CV_STUDIO_VIEW = 'CV_STUDIO_VIEW',
  CV_STUDIO_MANAGE = 'CV_STUDIO_MANAGE',
  CV_STUDIO_GENERATE = 'CV_STUDIO_GENERATE',
  CV_STUDIO_SHARE = 'CV_STUDIO_SHARE',
  CV_ISSUE_MODULE_ENTRY = 'CV_ISSUE_MODULE_ENTRY',
  CV_ISSUE_LIST = 'CV_ISSUE_LIST',
  CV_ISSUE_CREATE = 'CV_ISSUE_CREATE',
  CV_ISSUE_UPDATE = 'CV_ISSUE_UPDATE',
  CV_ISSUE_DELETE = 'CV_ISSUE_DELETE',
  CV_BOOKING_MY_LIST = 'CV_BOOKING_MY_LIST',
  CV_BOOKING_ALL_LIST = 'CV_BOOKING_ALL_LIST',
  CV_BOOKING_CREATE = 'CV_BOOKING_CREATE',
  CV_BOOKING_UPDATE = 'CV_BOOKING_UPDATE',
  CV_BOOKING_APPROVE = 'CV_BOOKING_APPROVE',
  CV_BOOKING_DECLINE = 'CV_BOOKING_DECLINE',
  RESOURCES_MODULE_ENTRY = 'RESOURCES_MODULE_ENTRY',
  RESOURCES_REFRESH_DATA_STUDIO = 'RESOURCES_REFRESH_DATA_STUDIO',

  PROJECTS_MODULE_ENTRY = 'PROJECTS_MODULE_ENTRY',
  PROJECTS_CREATE = 'PROJECTS_CREATE',
  PROJECTS_UPDATE = 'PROJECTS_UPDATE',
  PROJECTS_LIST = 'PROJECTS_LIST',
  PROJECTS_FULL_EDIT_ACCESS = 'PROJECTS_FULL_EDIT_ACCESS',
  PROJECTS_DESCRIPTION_UPDATE = 'PROJECTS_DESCRIPTION_UPDATE',
  PROJECTS_TASKS_EDIT_ONLY = 'PROJECTS_TASKS_EDIT_ONLY',
  PROJECTS_RESERVE_LINES_AND_INVOICE_SCHEDULE_DELETE = 'PROJECTS_RESERVE_LINES_AND_INVOICE_SCHEDULE_DELETE',
  PROJECTS_DETAILS = 'PROJECTS_DETAILS',
  PROJECT_DELIVERY_STATUS_MODULE_ENTRY = 'PROJECT_DELIVERY_STATUS_MODULE_ENTRY',

  PROJECTS_HISTORY = 'PROJECTS_HISTORY',
  PROJECTS_SETUP = 'PROJECTS_SETUP',
  PROJECTS_INVOICE_SCHEDULE = 'PROJECTS_INVOICE_SCHEDULE',
  PROJECTS_ORDER_RESERVE = 'PROJECTS_ORDER_RESERVE',
  PROJECTS_TASKS = 'PROJECTS_TASKS',

  REPORTS_MODULE_ENTRY = 'REPORTS_MODULE_ENTRY',
  REPORTS_ACCESS_SALES = 'REPORTS_ACCESS_SALES',

  MANAGER_MODULE_ENTRY = 'MANAGER_MODULE_ENTRY',
  CAPABILITY_MANAGER_MODULE_ENTRY = 'CAPABILITY_MANAGER_MODULE_ENTRY',
  CAPABILITY_SETUP_MODULE_ENTRY = 'CAPABILITY_SETUP_MODULE_ENTRY',
  CSAT_MODULE_ENTRY = 'CSAT_MODULE_ENTRY',
  EQUIPMENT_MODULE_ENTRY = 'EQUIPMENT_MODULE_ENTRY',
  CSAT_RATING_MODULE_ENTRY = 'CSAT_RATING_MODULE_ENTRY',

  CUSTOMER_MODULE_ENTRY = 'CUSTOMER_MODULE_ENTRY',
  CUSTOMERS_CREATE = 'CUSTOMERS_CREATE',
  CUSTOMERS_UPDATE = 'CUSTOMERS_UPDATE',
  CUSTOMERS_LIST = 'CUSTOMERS_LIST',
  CUSTOMERS_DELETE = 'CUSTOMERS_DELETE',

  LANDING_SEARCH_ADVISORS = 'LANDING_SEARCH_ADVISORS',
  CUSTOMERS_MODULE_ENTRY = 'CUSTOMERS_MODULE_ENTRY',
  CREATE_KNOWLEDGE_SHARING = 'CREATE_KNOWLEDGE_SHARING',
  DELETE_KNOWLEDGE_SHARING = 'DELETE_KNOWLEDGE_SHARING',
  UPDATE_KNOWLEDGE_SHARING = 'UPDATE_KNOWLEDGE_SHARING',
  LIST_EMPLOYEE_EDUCATION = 'LIST_EMPLOYEE_EDUCATION',
  CREATE_EMPLOYEE_EDUCATION = 'CREATE_EMPLOYEE_EDUCATION',
  DELETE_EMPLOYEE_EDUCATION = 'DELETE_EMPLOYEE_EDUCATION',
  UPDATE_EMPLOYEE_EDUCATION = 'UPDATE_EMPLOYEE_EDUCATION',
  LIST_EMPLOYEE_CERTIFICATE = 'LIST_EMPLOYEE_CERTIFICATE',
  CREATE_EMPLOYEE_CERTIFICATE = 'CREATE_EMPLOYEE_CERTIFICATE',
  UPDATE_EMPLOYEE_CERTIFICATE = 'UPDATE_EMPLOYEE_CERTIFICATE',
  DELETE_EMPLOYEE_CERTIFICATE = 'DELETE_EMPLOYEE_CERTIFICATE',
  COMPETENCE_DOMAIN_CREATE = 'COMPETENCE_DOMAIN_CREATE',
  COMPETENCE_DOMAIN_LIST = 'COMPETENCE_DOMAIN_LIST',
  COMPETENCE_DOMAIN_DELETE = 'COMPETENCE_DOMAIN_DELETE',
  PROJECT_EXPERIENCE_UPDATE = 'PROJECT_EXPERIENCE_UPDATE',
  PROJECT_EXPERIENCE_CREATE = 'PROJECT_EXPERIENCE_CREATE',
  PROJECT_EXPERIENCE_DELETE = 'PROJECT_EXPERIENCE_DELETE',
  PROJECT_EXPERIENCE_LIST = 'PROJECT_EXPERIENCE_LIST',
  PROJECT_EXPERIENCE_MODULE_ENTRY = 'PROJECT_EXPERIENCE_MODULE_ENTRY',
  PROJECT_EXPERIENCE_MANAGER = 'PROJECT_EXPERIENCE_MANAGER',
  CONSULTANT_SKILLS_TAB_ENTRY = 'CONSULTANT_SKILLS_TAB_ENTRY',
  SKILL_CREATE = 'SKILL_CREATE',
  SKILL_UPDATE = 'SKILL_UPDATE',
  SKILL_DELETE = 'SKILL_DELETE',
  CERTIFICATE_CREATE = 'CERTIFICATE_CREATE',
  CERTIFICATE_UPDATE = 'CERTIFICATE_UPDATE',
  CERTIFICATE_DELETE = 'CERTIFICATE_DELETE',
  CERTIFICATE_LIST = 'CERTIFICATE_LIST',
  SPECIALIZATION_CREATE = 'SPECIALIZATION_CREATE',
  SPECIALIZATION_LIST = 'SPECIALIZATION_LIST',
  SPECIALIZATION_DELETE = 'SPECIALIZATION_DELETE',
  SPECIALIZATION_UPDATE = 'SPECIALIZATION_UPDATE',
  SPECIALIZATION_CATEGORY_CREATE = 'SPECIALIZATION_CATEGORY_CREATE',
  SPECIALIZATION_CATEGORY_DELETE = 'SPECIALIZATION_CATEGORY_DELETE',
  SPECIALIZATION_CATEGORY_UPDATE = 'SPECIALIZATION_CATEGORY_UPDATE',

  STATIC_OBJECTS_MODULE_ENTRY = 'STATIC_OBJECTS_MODULE_ENTRY',
  STATIC_OBJECTS_LIST = 'STATIC_OBJECTS_LIST',
  STATIC_OBJECTS_CREATE = 'STATIC_OBJECTS_CREATE',
  STATIC_OBJECTS_UPDATE = 'STATIC_OBJECTS_UPDATE',
  STATIC_OBJECTS_DELETE = 'STATIC_OBJECTS_DELETE',

  TITLE_CREATE = 'TITLE_CREATE',
  TITLE_UPDATE = 'TITLE_UPDATE',
  TITLE_DELETE = 'TITLE_DELETE',
  PROJECT_CATEGORY_CREATE = 'PROJECT_CATEGORY_CREATE',
  PROJECT_CATEGORY_UPDATE = 'PROJECT_CATEGORY_UPDATE',
  PROJECT_CATEGORY_DELETE = 'PROJECT_CATEGORY_DELETE',
  ADD_NEW_SKILL_CERT_ENTRY = 'ADD_NEW_SKILL_CERT_ENTRY',

  CONSULTANT_SETTINGS_TAB_ENTRY = 'CONSULTANT_SETTINGS_TAB_ENTRY',

  REPORTED_HOURS_MODULE_ENTRY = 'REPORTED_HOURS_MODULE_ENTRY',

  CAREER_PLAN_LIST = 'CAREER_PLAN_LIST',
  CAREER_PLAN_CREATE = 'CAREER_PLAN_CREATE',
  CAREER_PLAN_UPDATE = 'CAREER_PLAN_UPDATE',
  CAREER_PLAN_DELETE = 'CAREER_PLAN_DELETE',

  CDP_PACKAGE_MODULE_ENTRY = 'CDP_PACKAGE_MODULE_ENTRY',
  CDP_PACKAGE_CREATE = 'CDP_PACKAGE_CREATE',
  CDP_PACKAGE_UPDATE = 'CDP_PACKAGE_UPDATE',
  CDP_ACTIVITY_CREATE = 'CDP_ACTIVITY_CREATE',
  CDP_ACTIVITY_UPDATE = 'CDP_ACTIVITY_UPDATE',

  PROJECT_ROLE_LIST = 'PROJECT_ROLE_LIST',
  PROJECT_ROLE_CREATE = 'PROJECT_ROLE_CREATE',
  PROJECT_ROLE_UPDATE = 'PROJECT_ROLE_UPDATE',
  PROJECT_ROLE_DELETE = 'PROJECT_ROLE_DELETE',

  MY_TEAM_MODULE_ENTRY = 'MY_TEAM_MODULE_ENTRY',
  MANAGER_EMPLOYEES_UPDATE = 'MANAGER_EMPLOYEES_UPDATE',
  MANAGER_EMPLOYEES_UPDATE_PRIVILEGED = 'MANAGER_EMPLOYEES_UPDATE_PRIVILEGED',
  MY_CAREER_MODULE_ENTRY = 'MY_CAREER_MODULE_ENTRY',

  CONSULTANT_PRICELIST_LIST = 'CONSULTANT_PRICELIST_LIST',
  CONSULTANT_PRICELIST_UPDATE = 'CONSULTANT_PRICELIST_UPDATE',

  PRICE_DISCOUNT_LIST = 'PRICE_DISCOUNT_LIST',
  PRICE_DISCOUNT_SAVE = 'PRICE_DISCOUNT_SAVE',
  PRICE_DISCOUNT_DELETE = 'PRICE_DISCOUNT_DELETE',

  BONUS_PARAMETERS_LIST = 'BONUS_PARAMETERS_LIST',
  BONUS_PARAMETERS_UPDATE = 'BONUS_PARAMETERS_UPDATE',
  BONUS_OVERRIDE_LIST = 'BONUS_OVERRIDE_LIST',
  BONUS_OVERRIDE_UPDATE = 'BONUS_OVERRIDE_UPDATE',


  REPORT_SUPERSET_LIST = 'REPORT_SUPERSET_LIST',
  REPORT_LOOKER_LIST = 'REPORT_LOOKER_LIST',
  REPORT_ACCESS_LIST = 'REPORT_ACCESS_LIST',
  REPORT_ACCESS_SAVE = 'REPORT_ACCESS_SAVE',
  REPORT_ACCESS_DELETE = 'REPORT_ACCESS_DELETE',

  DELIVERABLE_CREATE = 'DELIVERABLE_CREATE',
  DELIVERABLE_UPDATE = 'DELIVERABLE_UPDATE',

  OFFERING_CREATE = 'OFFERING_CREATE',
  OFFERING_UPDATE = 'OFFERING_UPDATE',
  OFFERING_DELETE = 'OFFERING_DELETE',
  OFFERING_LIST = 'OFFERING_LIST',

  MY_SALARY_MODULE_ENTRY = 'MY_SALARY_MODULE_ENTRY',

}

export enum GROUPS {
  ADMIN = 'ADMIN',
  USER = 'USER',
  VISITOR = 'VISITOR',
  EMPLOYEE = 'EMPLOYEE',
  MANAGER = 'MANAGER',
  MANAGER_RESOURCE = 'MANAGER_RESOURCE',
  MANAGER_PROJECT = 'MANAGER_PROJECT',
  MANAGER_CAPABILITY = 'MANAGER_CAPABILITY',
  MANAGER_CSAT = 'MANAGER_CSAT',
  MANAGER_GRADE_MATRIX = 'MANAGER_GRADE_MATRIX',
  MANAGER_KNOWLEDGE_SHARING = 'MANAGER_KNOWLEDGE_SHARING',
  CUSTOMER = 'CUSTOMER',
  MANAGER_CUSTOMER = 'MANAGER_CUSTOMER',
  MANAGER_ALLOCATION = 'MANAGER_ALLOCATION',
  SEARCH_WIZARD_MANGER = 'SEARCH_WIZARD_MANGER',
  SUB_CONTRACTOR = 'SUB_CONTRACTOR',
  EMPLOYEE_SALES = 'EMPLOYEE_SALES',
  EMPLOYEE_CONSULTANT = 'EMPLOYEE_CONSULTANT',
  EMPLOYEE_IT = 'EMPLOYEE_IT',
  EMPLOYEE_HR = 'EMPLOYEE_HR',
  EMPLOYEE_FINANCE = 'EMPLOYEE_FINANCE',
  VIRTUAL_LINE_MANAGER = 'VIRTUAL_LINE_MANAGER',
  BOOING_REQUEST_MODULE_ENTRY = 'BOOING_REQUEST_MODULE_ENTRY',
}

export enum REPORTS {
  SALARY_TCP_POLAND = 'salary-tcp-poland',
  SALARY_TCP_GCP = 'salary-tcp-gcp',
  BONUS_CALCULATION_REPORT = 'bonus-calculation-report-consultants',
}

export const tenantConfig = {
  cloudia: {
    title: 'Cloudia 2.0',
    faviconUrl: {
      PROD: '/assets/favicons/cloudia-favicon.png',
      STAGING: '/assets/favicons/cloudia-staging-favicon.png',
      TEST: '/assets/favicons/cloudia-test-favicon.png',
      LOCAL: '/assets/favicons/cloudia-local-favicon.png',
    },
    logoUrl: '/assets/images/cloudia-logo.svg',
    logoSmall: '/assets/images/cloudia-only-c.svg',
    defaultMeetingTitle: 'Meeting',
    guestPermissions: [],
    tenantNamesMappings: new Map<string, string>([
      ["Softline-Group", "Noventiq"]
    ])
  } as TenantConfig,
};

export interface TenantConfig {
  logoUrl: string;
  logoSmall: string;
  faviconUrl: {};
  title: string;
  guestPermissions: string[];
  defaultMeetingTitle: string;
}
